import React, { useEffect, useState } from "react";
import "./packagehome.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";
import { Helmet } from "react-helmet";

const PackageHome = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="packagehome">
      <Helmet>
        <title>Egypt Travel Packages | Myths Egypt Tours</title>
        <meta
          name="description"
          content="Discover our Egypt travel packages including Nile cruises, Cairo & Luxor tours, desert safaris, and more with Myths Egypt Tours."
        />
        <meta
          name="keywords"
          content="Egypt travel packages, Nile cruises, Myths Egypt Tours, Cairo tours, Luxor trips"
        />
        <meta property="og:title" content="Egypt Travel Packages | Myths Egypt Tours" />
        <meta
          property="og:description"
          content="Choose from a variety of Egypt travel packages crafted by Myths Egypt Tours. Explore Cairo, Luxor, Aswan, and beyond."
        />
        <meta property="og:url" content="https://mythsegypttours.com/packages" />
        <meta property="og:image" content="https://mythsegypttours.com/og-image.jpg" />
      </Helmet>

      <Banner page="packages" />
    </section>
  );
};

export default PackageHome;
